module.exports = function getResource(label, vars = []) {
    let resources = {
        //BasketList
        itemsInBasketMessage: `Items in basket (${vars[0]})`,
        emptyBasketMessage: 'Your basket is currently empty.',
        shopNewArrivals: 'Shop New Arrivals',
        pleaseSignIn: `Please ${vars[0]} if you are trying to retrieve a basket created in the past.`,
        signInText: 'sign in',
        emptyRopisBasketTitle: 'Empty Basket',
        emptyRopisBasket: 'Your Reserve & Pick Up basket is empty. You will be taken to your online order basket',
        ok: 'OK',

        //BasketListItem
        shippingRestrictionPopoverText: 'Due to shipping regulations, this item and the rest of your order must ship ground (2-8 days total delivery time). This includes FLASH and expedited orders.',
        shippingRestrictions: 'Shipping Restrictions',
        rewardCardText: 'Rouge Reward is valid on *a future transaction only*, it *expires in 90 days*, and it will be sent via email within *24 hours*.',
        remove: 'Remove',
        moveToLoves: 'Move to Loves',
        loved: 'Loved',
        outOfStock: 'out of stock',
        outOfStockAtStore: 'Out of Stock at Selected Store',
        soldOut: 'sold out'
    };

    return resources[label];
};
